import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';

/* TODO: delete this component
This is just a temporary component used to proxy to the new activate products url.
Account create currently sends to a different url, but it is in Knockout land.
 */
@Component({
  selector: 'app-product-order-form-proxy',
  template: ``,
  standalone: false,
})
export class ProductOrderFormProxyComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const accountGroupId$ = this.route.queryParams.pipe(
      map((params) => params.agid || params.accountGroupId),
      filter(Boolean),
      first(),
    );

    combineLatest([accountGroupId$, this.route.queryParams])
      .pipe(first())
      .subscribe(([agid, params]) => {
        this.router.navigate([`businesses/accounts/${agid}/activation/order-form`], {
          queryParams: {
            accountGroupId: agid,
            ...params,
          },
        });
      });
  }
}
